import React from "react";
import { Lock, Sparkles } from "lucide-react";

const juntar = (lista) => {
  const itens = (lista || []).filter(Boolean);
  if (itens.length <= 1) return itens[0] || "dados";
  return `${itens.slice(0, -1).join(", ")} e ${itens[itens.length - 1]}`;
};

// Aviso pro atendente: o cliente escolhido tem ofertas hoje e o que já entrou no carrinho.
export default function AvisoOfertasCliente({ ofertasDia, cart, className = "" }) {
  const estado = ofertasDia?.estado;
  const total = ofertasDia?.total || 0;
  if (estado === "bloqueado" && total > 0) {
    return (
      <div className={`rounded-lg border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-xs flex items-start gap-2 ${className}`} data-e2e="aviso-ofertas-cliente">
        <Lock className="w-3.5 h-3.5 mt-0.5 shrink-0 text-amber-600" />
        <span>
          <b>Campanha Inteligente:</b> este cliente tem {total} {total === 1 ? "oferta" : "ofertas"} hoje, mas falta{" "}
          {juntar(ofertasDia.faltando_rotulos)} no cadastro pra liberar.
        </span>
      </div>
    );
  }
  if (estado !== "ativo" || total === 0) return null;
  const aplicados = (cart || []).filter((it) => it.oferta_chave);
  return (
    <div className={`rounded-lg border border-primary/40 bg-primary/10 px-3 py-2 text-xs flex items-start gap-2 ${className}`} data-e2e="aviso-ofertas-cliente">
      <Sparkles className="w-3.5 h-3.5 mt-0.5 shrink-0 text-primary" />
      <span>
        <b>Campanha Inteligente:</b> {total} {total === 1 ? "oferta" : "ofertas"} hoje pra este cliente.{" "}
        {aplicados.length > 0
          ? <>No carrinho: {aplicados.map((it) => `${it.name || it.nome} −${String(it.oferta_desconto_pct).replace(".", ",")}%`).join(", ")}.</>
          : "Os produtos em oferta ficam mais baratos quando entram no carrinho."}
      </span>
    </div>
  );
}
